export enum ContentLinkModifier {
  REGULAR = 'content-link--regular',
}
